import React from 'react';
import { marqueeItems } from '../data/content';

export default function Marquee() {
  const items = [
    ...marqueeItems.map((text) => ({ key: `${text}-a`, text })),
    ...marqueeItems.map((text) => ({ key: `${text}-b`, text }))
  ];
  return (
    <div className="relative border-y border-steelline/60 bg-surface/60 py-5 overflow-hidden" data-testid="marquee-band">
      <div className="marquee-track flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {items.map(({ key, text: item }, i) => (
          <span key={key} className="flex items-center gap-10">
            <span className={`font-display text-xl md:text-2xl font-bold tracking-wide ${i % 2 === 0 ? 'text-paper/80' : 'text-outline'}`}>
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-flame" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
